var swiper = new Swiper(".carosuel-section .mySwiper", {
  slidesPerView: 1.1,
  spaceBetween: 10,
  loop: true,
  pagination: {
    el: ".swiper-pagination.carousel-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next.carousel-arrow-next",
    prevEl: ".swiper-button-prev.carousel-arrow-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 2.2,
      spaceBetween: 30,
      loop: true,
      loopedSlides: 3,
      centeredSlides: false,
    },
  },
});
